import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-900 border-t border-white/5 pt-16 pb-8 text-white relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-aseBlue/5 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12">
          
          {/* Logo & Brand */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <Link to="/" className="flex items-center gap-3 group">
              <div className="relative">
                <img src="/logo.png" alt="ASE Logo" className="h-10 w-10 rounded-lg shadow-lg relative z-10" />
                <div className="absolute inset-0 bg-aseBlue rounded-lg blur-md opacity-0 group-hover:opacity-50 transition duration-300"></div>
              </div>
              <span className="text-base font-display font-bold tracking-tight">ALLIED SOFTWARE ENGINEERS (PRIVATE) LIMITED</span>
            </Link>
            <p className="text-gray-400 text-sm max-w-xs text-center md:text-left">
              Engineering the future with scalable, secure, and intelligent technology solutions.
            </p>
          </div>

          {/* Links */}
          <div className="flex gap-6 text-sm font-medium text-gray-400">
            <Link to="/vision" className="hover:text-white transition-colors">Vision</Link>
            <Link to="/team" className="hover:text-white transition-colors">Our Team</Link>
            <Link to="/careers" className="hover:text-white transition-colors">Careers</Link>
            <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8"></div>

        {/* Bottom Bar */}
        <div className="flex flex-col items-center justify-center text-xs text-gray-500">
          <p>
            © {new Date().getFullYear()} <b>ALLIED SOFTWARE ENGINEERS (PRIVATE) LIMITED</b>. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}